import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { BaseInput } from "../../components/Base/BaseInput";
import { useBookingContext } from "../../context/BookingContext";
import { Box, Button, Grid, GridItem } from "@chakra-ui/react";
import {
  BookCard,
  BookCardTitle,
  BookCardSubtitle,
} from "../../components/Book/BookCard";
import { SingleDatepicker } from "chakra-dayzed-datepicker";

const ChildInfoPage = () => {
  const history = useHistory();

  const { stepr } = useBookingContext();

  const handleClickContinue = () => {
    /**
     * TODO: validate form
     */
    stepr.nextStep();
    history.push("/book/select-class");
  };

  useEffect(() => {
    stepr.setStep(1);
  }, [stepr]);

  return (
    <BookCard mt={"10px"} mx="auto">
      <Box display={"flex"} justifyContent={"space-between"}>
        <Box>
          <BookCardTitle small>Child information</BookCardTitle>
          <BookCardSubtitle small>Please enter child details</BookCardSubtitle>
        </Box>
        <Box color="#797979" fontSize={"20px"}>
          <i className="ri-information-fill"></i>
        </Box>
      </Box>

      <Grid templateColumns="repeat(2, 1fr)" gap={"10px"} mt={6}>
        <GridItem>
          <BaseInput name="first-name" label="First Name" placeholder="John" />
        </GridItem>
        <GridItem>
          <BaseInput name="last-name" label="Last Name" placeholder="Doe" />
        </GridItem>
        <GridItem colSpan={2} mt={2}>
          <BaseInput
            name="dob"
            label="Date of Birth"
            customInput={(a, b, attrs) => (
              <SingleDatepicker
                name="date-input"
                date={a}
                onDateChange={b}
                {...attrs}
              />
            )}
          />
        </GridItem>
        <GridItem colSpan={2} mt={2}>
          <BaseInput
            textarea
            name="about"
            label="Anything you would like us to know about your child (e.g. diagnoses, etc)"
            placeholder="Write here"
          />
        </GridItem>

        <GridItem colSpan={2} mt={2}>
          <Button
            w={"100%"}
            variant="solid"
            colorScheme="blue"
            fontFamily={"Cairo"}
            fontSize={"14px"}
            fontWeight={700}
            onClick={handleClickContinue}
          >
            Continue
          </Button>
        </GridItem>
      </Grid>
    </BookCard>
  );
};

export { ChildInfoPage };
